module.exports = __webpack_public_path__ + "static/assets/f6ea8c31a79f19664c83406d350a895c.svg";